import React from "react";
import LazyLoad from "react-lazyload";

import "./LazyImage.css";

const LazyImage = ({ classNameImg = "", src, alt, height }) => {
  const refPlaceholder = React.useRef();

  const removePlaceholder = () => {
    refPlaceholder.current.remove();
  };

  return (
    <div className="image-wrapper" style={{ height: height }}>
      <div className="placeholder" ref={refPlaceholder} />
      <LazyLoad>
        <img
          className={classNameImg}
          style={{
            position: "absolute",
            left: "0",
            width: "100%",
            height: "100%",
            objectFit: "cover",
          }}
          src={src}
          alt={alt}
          onLoad={removePlaceholder}
          onError={removePlaceholder}
        />
      </LazyLoad>
    </div>
  );
};

export default LazyImage;
